/*
  Modulo di recesso (art. 54-bis Codice del Consumo).
  - Precompila numero d'ordine, data, nome ed email dai parametri della query
    string, così il pulsante "Recesso dal contratto" sulla pagina di un ordine
    porta a un modulo già compilato.
  - Mostra il campo dei prodotti solo per il recesso parziale.
  - Al momento dell'invio marca data e ora nel campo nascosto e conserva il
    riepilogo per la ricevuta, che Shopify non restituisce dopo il redirect.
  - Sulla ricevuta ricompone il riepilogo e genera il PDF da salvare.

  Il PDF è scritto a mano (Helvetica, WinAnsiEncoding): la ricevuta è solo
  testo, quindi una libreria esterna costerebbe centinaia di kB per nulla.
  L'unica azione offerta è il salvataggio del file: niente dialogo di stampa.
  Il pulsante nasce nascosto e compare solo dove il download funziona davvero.

  Tutto degrada senza JavaScript: il modulo resta compilabile e inviabile, e la
  ricevuta mantiene comunque data e ora rese dal server.
*/

(function () {
  var CHIAVE = 'taste:recesso:ultimo-invio';

  /* ---------- Modulo ---------- */

  function precompila(form) {
    var parametri = new URLSearchParams(window.location.search);
    var mappa = {
      order: ['ordine', 'order'],
      order_date: ['data', 'date'],
      name: ['nome', 'name'],
      email: ['email']
    };

    Object.keys(mappa).forEach(function (chiave) {
      var campo = form.querySelector('[data-recesso-prefill="' + chiave + '"]');
      if (!campo || campo.value) return;

      for (var i = 0; i < mappa[chiave].length; i++) {
        var valore = parametri.get(mappa[chiave][i]);
        if (valore) {
          campo.value = valore;
          break;
        }
      }
    });
  }

  function gestisciEstensione(form) {
    var contenitore = form.querySelector('[data-recesso-products]');
    var parziale = form.querySelector('[data-recesso-scope="partial"]');
    if (!contenitore || !parziale) return;

    var testo = contenitore.querySelector('textarea');

    function aggiorna() {
      contenitore.hidden = !parziale.checked;
      if (testo) testo.required = parziale.checked;
    }

    form.querySelectorAll('[data-recesso-scope]').forEach(function (radio) {
      radio.addEventListener('change', aggiorna);
    });

    aggiorna();
  }

  // Etichetta leggibile a partire da name="contact[Numero ordine]"
  function etichetta(campo) {
    var nome = campo.getAttribute('name') || '';
    var trovato = nome.match(/^contact\[(.+)\]$/);
    if (!trovato) return '';
    if (trovato[1] === 'email') return 'Email';
    return trovato[1];
  }

  function riepilogo(form) {
    var righe = [];
    var visti = {};

    form.querySelectorAll('input, textarea, select').forEach(function (campo) {
      var nome = etichetta(campo);
      if (!nome || nome === 'Dichiarazione' || nome === 'Data e ora di invio') return;
      if (campo.type === 'radio' && !campo.checked) return;
      if (!campo.value || !campo.value.trim()) return;
      if (visti[nome]) return;

      visti[nome] = true;
      righe.push({ etichetta: nome, valore: campo.value.trim() });
    });

    return righe;
  }

  function preparaInvio(form) {
    form.addEventListener('submit', function () {
      var adesso = new Date();
      var marcatore = form.querySelector('[data-recesso-timestamp]');
      if (marcatore) marcatore.value = adesso.toLocaleString('it-IT');

      try {
        sessionStorage.setItem(
          CHIAVE,
          JSON.stringify({ inviato: adesso.toISOString(), righe: riepilogo(form) })
        );
      } catch (errore) {
        // Storage negato (navigazione privata o cookie bloccati): la ricevuta
        // resta valida, mostra solo data e ora rese dal server.
      }
    });
  }

  /* ---------- Ricevuta ---------- */

  function mostraRiepilogo(ricevuta) {
    var elenco = ricevuta.querySelector('[data-recesso-summary]');
    if (!elenco) return;

    var dati = null;
    try {
      dati = JSON.parse(sessionStorage.getItem(CHIAVE) || 'null');
    } catch (errore) {
      dati = null;
    }

    if (dati && dati.righe && dati.righe.length) {
      dati.righe.forEach(function (riga) {
        var blocco = document.createElement('div');
        blocco.className = 'recesso__receipt-row';

        var titolo = document.createElement('dt');
        titolo.textContent = riga.etichetta;

        var valore = document.createElement('dd');
        valore.textContent = riga.valore;

        blocco.appendChild(titolo);
        blocco.appendChild(valore);
        elenco.appendChild(blocco);
      });
    }

    elenco.hidden = false;
  }

  /* ---------- Generazione del PDF ---------- */

  var PAGINA = { larghezza: 595, altezza: 842, margine: 56 };
  var UTILE = PAGINA.larghezza - PAGINA.margine * 2;

  // Il PDF usa WinAnsiEncoding (un byte per carattere): le virgolette e i
  // trattini tipografici non ci stanno e vengono riportati agli equivalenti
  // ASCII, il resto oltre il byte diventa un punto interrogativo.
  function aWinAnsi(testo) {
    var normalizzato = String(testo)
      .replace(/[‘’‛]/g, "'")
      .replace(/[“”]/g, '"')
      .replace(/[‐-―]/g, '-')
      .replace(/…/g, '...')
      .replace(/€/g, 'EUR')
      .replace(/ /g, ' ');

    var risultato = '';
    for (var i = 0; i < normalizzato.length; i++) {
      var codice = normalizzato.charCodeAt(i);
      risultato += codice <= 0xff ? normalizzato[i] : '?';
    }
    return risultato;
  }

  function escapePdf(testo) {
    return testo.replace(/([\\()])/g, '\\$1');
  }

  // Larghezza media di Helvetica: basta per non sforare il margine destro.
  function avvolgi(testo, dimensione) {
    var massimo = Math.floor(UTILE / (dimensione * 0.5));
    var righe = [];

    String(testo)
      .split('\n')
      .forEach(function (paragrafo) {
        var corrente = '';

        paragrafo.split(/\s+/).forEach(function (parola) {
          if (!parola) return;
          if (!corrente) {
            corrente = parola;
          } else if ((corrente + ' ' + parola).length <= massimo) {
            corrente += ' ' + parola;
          } else {
            righe.push(corrente);
            corrente = parola;
          }
        });

        righe.push(corrente);
      });

    return righe.length ? righe : [''];
  }

  function comandoTesto(x, y, dimensione, grassetto, testo) {
    return (
      'BT\n/' + (grassetto ? 'F2' : 'F1') + ' ' + dimensione + ' Tf\n' +
      x + ' ' + y + ' Td\n(' + escapePdf(aWinAnsi(testo)) + ') Tj\nET\n'
    );
  }

  function comandoFiletto(y) {
    return (
      '0.5 w\n' + PAGINA.margine + ' ' + y + ' m ' +
      (PAGINA.larghezza - PAGINA.margine) + ' ' + y + ' l S\n'
    );
  }

  // Trasforma l'elenco dei blocchi in flussi di contenuto, uno per pagina.
  function impagina(blocchi) {
    var pagine = [];
    var corrente = '';
    var y = PAGINA.altezza - PAGINA.margine;

    function nuovaPagina() {
      if (corrente) pagine.push(corrente);
      corrente = '';
      y = PAGINA.altezza - PAGINA.margine;
    }

    blocchi.forEach(function (blocco) {
      if (blocco.tipo === 'filetto') {
        if (y - 12 < PAGINA.margine) nuovaPagina();
        y -= 12;
        corrente += comandoFiletto(y);
        y -= 10;
        return;
      }

      var dimensione = blocco.dimensione;
      var interlinea = Math.round(dimensione * 1.4);

      avvolgi(blocco.testo, dimensione).forEach(function (riga) {
        if (y - interlinea < PAGINA.margine) nuovaPagina();
        y -= interlinea;
        corrente += comandoTesto(PAGINA.margine, y, dimensione, blocco.grassetto, riga);
      });

      y -= blocco.spazio || 0;
    });

    if (corrente) pagine.push(corrente);
    return pagine.length ? pagine : [''];
  }

  function costruisciPdf(pagine) {
    var oggetti = [];
    var primaPagina = 5; // 1 catalogo, 2 albero pagine, 3 e 4 i due font
    var figli = [];

    for (var i = 0; i < pagine.length; i++) figli.push(primaPagina + i * 2 + ' 0 R');

    oggetti.push('<< /Type /Catalog /Pages 2 0 R >>');
    oggetti.push('<< /Type /Pages /Kids [' + figli.join(' ') + '] /Count ' + pagine.length + ' >>');
    oggetti.push('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>');
    oggetti.push('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>');

    pagine.forEach(function (contenuto, indice) {
      var idContenuto = primaPagina + indice * 2 + 1;
      oggetti.push(
        '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + PAGINA.larghezza + ' ' + PAGINA.altezza + ']' +
          ' /Resources << /Font << /F1 3 0 R /F2 4 0 R >> >> /Contents ' + idContenuto + ' 0 R >>'
      );
      oggetti.push('<< /Length ' + contenuto.length + ' >>\nstream\n' + contenuto + '\nendstream');
    });

    var pdf = '%PDF-1.4\n';
    var scostamenti = [];

    oggetti.forEach(function (oggetto, indice) {
      scostamenti.push(pdf.length);
      pdf += indice + 1 + ' 0 obj\n' + oggetto + '\nendobj\n';
    });

    var inizioXref = pdf.length;
    pdf += 'xref\n0 ' + (oggetti.length + 1) + '\n0000000000 65535 f \n';
    scostamenti.forEach(function (scostamento) {
      pdf += ('0000000000' + scostamento).slice(-10) + ' 00000 n \n';
    });
    pdf +=
      'trailer\n<< /Size ' + (oggetti.length + 1) + ' /Root 1 0 R >>\n' +
      'startxref\n' + inizioXref + '\n%%EOF';

    // Ogni carattere è ormai un byte: la conversione è diretta.
    var byte = new Uint8Array(pdf.length);
    for (var i = 0; i < pdf.length; i++) byte[i] = pdf.charCodeAt(i) & 0xff;
    return byte;
  }

  function blocchiRicevuta(ricevuta) {
    var blocchi = [];
    var negozio = ricevuta.getAttribute('data-recesso-shop') || '';
    var indirizzo = ricevuta.getAttribute('data-recesso-shop-url') || '';
    var titolo = ricevuta.querySelector('.recesso__receipt-title');

    blocchi.push({
      tipo: 'testo',
      testo: (titolo ? titolo.textContent : 'Ricevuta di recesso').replace(/\s+/g, ' ').trim(),
      dimensione: 18,
      grassetto: true,
      spazio: 4
    });

    if (negozio) {
      blocchi.push({ tipo: 'testo', testo: negozio, dimensione: 10, grassetto: false, spazio: 0 });
    }
    if (indirizzo) {
      blocchi.push({ tipo: 'testo', testo: indirizzo, dimensione: 10, grassetto: false, spazio: 0 });
    }

    blocchi.push({ tipo: 'filetto' });

    ricevuta.querySelectorAll('.recesso__receipt-row').forEach(function (riga) {
      var nome = riga.querySelector('dt');
      var valore = riga.querySelector('dd');
      if (!nome || !valore) return;

      blocchi.push({
        tipo: 'testo',
        testo: nome.textContent.trim(),
        dimensione: 10,
        grassetto: true,
        spazio: 2
      });
      blocchi.push({
        tipo: 'testo',
        testo: valore.textContent.trim(),
        dimensione: 11,
        grassetto: false,
        spazio: 10
      });
    });

    blocchi.push({ tipo: 'filetto' });
    blocchi.push({
      tipo: 'testo',
      testo:
        'Ricevuta della comunicazione di recesso trasmessa tramite il sito del venditore, ai sensi ' +
        "dell'art. 54-bis del Codice del Consumo. Conservala come prova dell'avvenuta comunicazione.",
      dimensione: 9,
      grassetto: false,
      spazio: 0
    });

    return blocchi;
  }

  function nomeFile(ricevuta) {
    var nome = 'ricevuta-recesso';

    ricevuta.querySelectorAll('.recesso__receipt-row').forEach(function (riga) {
      var etichettaRiga = riga.querySelector('dt');
      var valore = riga.querySelector('dd');
      if (!etichettaRiga || !valore) return;
      if (etichettaRiga.textContent.trim().toLowerCase() !== 'numero ordine') return;

      var pulito = valore.textContent
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      if (pulito) nome += '-' + pulito;
    });

    return nome + '.pdf';
  }

  function preparaPdf(ricevuta) {
    var pulsante = ricevuta.querySelector('[data-recesso-pdf]');
    if (!pulsante) return;

    // Senza Blob, object URL o attributo download il file non arriverebbe da
    // nessuna parte: meglio non mostrare un pulsante che non fa niente.
    var scaricabile =
      typeof Blob === 'function' &&
      typeof URL !== 'undefined' &&
      typeof URL.createObjectURL === 'function' &&
      'download' in document.createElement('a');

    if (!scaricabile) return;

    pulsante.hidden = false;
    pulsante.addEventListener('click', function () {
      var byte = costruisciPdf(impagina(blocchiRicevuta(ricevuta)));
      var indirizzo = URL.createObjectURL(new Blob([byte], { type: 'application/pdf' }));
      var link = document.createElement('a');

      link.href = indirizzo;
      link.download = nomeFile(ricevuta);
      document.body.appendChild(link);
      link.click();
      link.remove();

      // Revoca ritardata: alcuni browser leggono il blob dopo il click.
      setTimeout(function () {
        URL.revokeObjectURL(indirizzo);
      }, 10000);
    });
  }

  /* ---------- Avvio ---------- */

  function avvia() {
    document.querySelectorAll('.recesso__form').forEach(function (form) {
      if (form.dataset.recessoInit) return;
      form.dataset.recessoInit = 'true';

      precompila(form);
      gestisciEstensione(form);
      preparaInvio(form);
    });

    document.querySelectorAll('[data-recesso-receipt]').forEach(function (ricevuta) {
      if (ricevuta.dataset.recessoInit) return;
      ricevuta.dataset.recessoInit = 'true';

      mostraRiepilogo(ricevuta);
      preparaPdf(ricevuta);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  // L'editor del tema ricarica la sezione senza ricaricare la pagina
  document.addEventListener('shopify:section:load', avvia);
})();
